<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div>
    <div style="line-height: 15px" class="p-2">
      <br />
      <label>{{ leilao.cidade }} / {{ leilao.estado }}</label>
      <p style="line-height: 25px">
        {{ leilao.leilao_titulo }}
        <br />
        {{ leilao.leilao_descricao }}
      </p>
    </div>
    <br />

    <div class="card card-primary">
      <div class="card-header">
        <h3 class="card-title">Adicionar foto</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <!-- INSTRUÇÕES -->
          <div class="col-sm-12">
            <div class="form-group">
              <span style="color: red">Instruções: Imagem 400x250 e Fundo branco ou transparente</span>
            </div>
            <br />
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <div class="input-group">
                <div class="custom-file">
                  <input class="form-control" type="file" @change="onChangeFotos" multiple="multiple" style="height: 80px; margin-bottom: 25px" />
                </div>
              </div>
            </div>
            <button @click="sendFileS3()" class="btn btn-info">Enviar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- TABELA DE FOTOS -->
    <div class="card" v-if="fotos">
      <div class="card-header">
        <h3 class="card-title">Fotos</h3>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover text-nowrap">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Lote</th>
              <th>Miniatura</th>
              <th>Texto alternativo</th>
              <th style="width: 10%">Destaque</th>
              <th>Remover</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(foto, index) in fotos" :key="foto">
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Lote">{{ foto.lote_id }}</td>
              <td data-label="Miniatura">
                <img
                  data-toggle="modal"
                  data-target="#image-modal"
                  @click="foto_selecionada = foto"
                  style="cursor: pointer"
                  width="90px"
                  height="50px"
                  :src="getImagePath(foto)"
                />
              </td>

              <td data-label="Texto alternativo">
                <div class="input-group">
                  <div class="input-group input-group-sm" style="width: 100%">
                    <div class="input-group-append">
                      <button class="btn" type="submit" style="margin-right: 5px" @click="foto.edit = true" v-if="!foto.edit">
                        <i class="fas fa-pen"></i>
                      </button>
                      <button class="btn" type="submit" style="margin-right: 5px" @click="updateFoto(foto)" v-if="foto.edit">
                        <i class="fas fa-check" style="color: green"></i>
                      </button>
                    </div>

                    <form v-on:submit.prevent="editarNome(foto)">
                      <input type="text" class="form-control" :disabled="!foto.edit" v-model="foto.alt" @click="foto.edit = true" />
                    </form>
                  </div>
                </div>
              </td>

              <td>
                <input type="checkbox" id="agreeTerms" name="terms" value="agree" v-model="foto.destaque" @change="updateFoto(foto)" />
              </td>

              <td>
                <button class="btn btn-info" @click="deletar(foto)">Remover</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal fade" id="image-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content" style="background-color: #4a4949">
            <div class="modal-body">
              <img
                style="position: relative; max-height: 1700px; max-width: 1500px; object-fit: contain"
                :src="getImageFoto(foto_selecionada)"
                class="product-image im"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + logos.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["leilao", "lotes"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      logo_selecionado: "",
      filtro: "",
      paginas: [],
      logos: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      arquivoFotos: "",
      fotos: "",
      aux_lotes: [],
      foto_selecionada: "",
      lote_selecionado: "",
    };
  },

  mounted() {
    console.log(this.lote);

    for (let i = 0; i < this.lotes.length; i++) {
      this.aux_lotes.push(this.lotes[i]);
    }

    this.buscarFotos();
  },

  methods: {
    getImageFoto(foto) {
      if (foto.path && foto.path.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + foto.path + "/" + foto.img;
      } else if ((foto.path && foto.path.includes("rochaleiloes")) || (foto.img && foto.img.includes("fotos_"))) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + foto.path + "/" + foto.img;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + foto.path + "/" + foto.img;
      }
    },

    getImagePath(foto) {
      if (foto.path && foto.path.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + foto.path + "/" + foto.img;
      } else if ((foto.path && foto.path.includes("rochaleiloes")) || (foto.img && foto.img.includes("fotos_"))) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + foto.path + "/" + foto.img;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + foto.path + "/" + foto.img;
      }
    },

    deletar(foto) {
      console.log("Deletando");
      console.log(foto);

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar esta foto? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: foto.id,
            };

            console.log("Deletando foto");
            console.log(data);

            axios
              .post(`/admin/foto/delete`, data)
              .then((response) => {
                this.showSuccessMessage("Foto deletada!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    sendFileS3() {
      if (this.arquivoFotos && this.arquivoFotos.length && this.arquivoFotos.length > 0) {
        this.isLoading = true;

        let invalid_lote_name = false;
        let fileName = "";

        for (let i = 0; i < this.arquivoFotos.length; i++) {
          console.log(this.arquivoFotos[i]);
          let lote_id = this.getLoteId(this.arquivoFotos[i].name);

          if (lote_id >= 0) {
            this.arquivoFotos[i].lote_id = lote_id;
          } else {
            //REMOVENDO EXTENSÃO DO ARQUIVO
            let somente_nome = this.arquivoFotos[i].name.split(".")[0];

            //PEGAR SOMENTE O NÚMERO QUE VEM ANTES DO "-"
            let nome_final = somente_nome.split("-")[0];

            invalid_lote_name = true;
            fileName = nome_final;
            break;
          }
        }

        if (invalid_lote_name) {
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops...", "Não foi possível localizar o lote de núnmero " + fileName);
        } else {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("id", "1");
            formData.append("path", "rochaleiloes2/lotes/");

            for (let i = 0; i < this.arquivoFotos.length; i++) {
              formData.append("files", this.arquivoFotos[i]);
            }

            let lotes_formatados = [];

            for (let i = 0; i < this.lotes.length; i++) {
              lotes_formatados.push({
                id: this.lotes[i].id,
                lote_numero: this.lotes[i].lote_numero,
              });
            }

            formData.append("lotes", JSON.stringify(lotes_formatados));

            console.log("Arquivos");
            console.log(this.arquivoFotos);

            axios
              .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/bulk-upload-multiple/water-mark`, formData)
              .then((response) => {
                console.log(response.data);
                console.log("ENVIANDO PARA O BANCO\n");

                this.uploadFoto(response.data.files);
              })
              .catch((error) => {
                console.log(error);
                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error.response.data.error);
                reject();
              });
          });
        }
      } else {
        this.showErrorMessageWithButton("Ops...", "Selecione uma ou mais fotos para enviar.");
      }
    },

    async uploadFoto(files) {
      let arr_arquivos = [];

      for (let i = 0; i < files.length; i++) {
        //DEFININDO ARQUIVO
        let fileName = files[i].file.split("/");

        let file = {
          file: fileName[fileName.length - 1],
          originalName: files[i].originalName,
          path: files[i].path,
        };

        if (files[i].thumb) {
          console.log("Tem thumb sim");
          //DEFININDO THUMB
          let thumb_name = files[i].thumb.split("/");

          file.thumb = thumb_name[fileName.length - 1];
        }

        console.log("File");
        console.log(file);
        arr_arquivos.push(file);
      }

      let data = {
        files: arr_arquivos,
        leilao_id: this.leilao.id,
      };

      console.log("Enviando agora");
      console.log(data);

      axios
        .post(`/admin/fotos/bulkStore`, data)
        .then((response) => {
          console.log("Resposta");
          console.log(response.data);

          if (response.data.success) {
            this.showSuccessMessage("Foto(s) cadastrada(s)!");

            window.location.reload();
          } else {
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    getLoteId(filename) {
      //REMOVENDO EXTENSÃO DO ARQUIVO
      let somente_nome = filename.split(".")[0];

      //PEGAR SOMENTE O NÚMERO QUE VEM ANTES DO "-"
      let nome_final = somente_nome.split("-")[0];

      for (let i = 0; i < this.lotes.length; i++) {
        if (nome_final == this.lotes[i].lote_numero) {
          console.log("Retornando lote " + this.lotes[i].lote_numero);

          return this.lotes[i].id;
        }
      }

      console.log("Não encontrou para o nome " + nome_final);

      return -1;
    },

    updateFoto(foto) {
      console.log("Editando documento");
      foto.edit = false;

      let data = {
        id: foto.id,
        destaque: foto.destaque == 1,
        alt: foto.alt,
      };

      axios
        .post(`/admin/foto/update`, data)
        .then((response) => {
          this.showSuccessMessage("Foto atualizada");
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    onChangeFotos(e) {
      //this.arquivo_leilao = e.target.files[0];

      this.arquivoFotos = [];

      for (let i = 0; i < e.target.files.length; i++) {
        this.arquivoFotos.push(e.target.files[i]);
      }
    },

    loteAnterior() {
      let indice = this.lotes.findIndex((element) => element["id"] == this.lote.id);

      if (indice - 1 >= 0 && indice < this.lotes.length) {
        window.location.href = "/admin/fotos/" + this.lotes[indice - 1].id;
      } else {
        this.showErrorMessage("Nenhum lote encontrado");
      }

      return indice;
    },

    alternarLote() {
      window.location.href = "/admin/fotos/" + this.lote_selecionado.id;
    },

    proximoLote() {
      let indice = this.lotes.findIndex((element) => element["id"] == this.lote.id);

      if (indice + 1 < this.lotes.length) {
        window.location.href = "/admin/fotos/" + this.lotes[indice + 1].id;
      } else {
        this.showErrorMessage("Nenhum lote encontrado");
      }

      return indice;
    },

    getUrlEdit(logo) {
      return "/admin/logo/" + logo.id;
    },

    show(logo) {
      this.logo_selecionado = logo;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarFotos();
      }
    },

    buscarFotos() {
      this.isLoading = true;

      let data = {
        leilao_id: this.leilao.id,
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      axios
        .post(`/admin/fotos/search_by_leilao`, data)
        .then((response) => {
          this.isLoading = false;

          this.fotos = response.data.fotos;
          this.total = response.data.total;
          console.log("Fotos");
          console.log(this.fotos);

          for (let i = 0; i < this.fotos.length; i++) {
            this.fotos[i].destaque = this.fotos[i].destaque == 1;
          }

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarFotos();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.im {
  width: 1000px;
}

.modal-content {
  width: 1040px;
  margin-left: -250px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 900px;
    margin-left: -00px;
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 900px;
    margin-left: -180px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
